import { makeEntityScaffold } from '@classpass/saga-tools';
import { transformClientResponse } from 'helpers/core';
import URLS from 'constants/urls';
import { VENUE_FEATURE_PROBE_HTTP_CONFIG } from 'helpers/session-auth-http';

// TODO(kamil): Remove this part when MS-995 will be Done
const removeClassesWithWhitespaceOnlyNames = data => data.filter(({ name }) => /\S/.test(name));

const handler = ({ httpClient }, venueId, { count } = {}) => {
  const endpoint = URLS.msSchedules.classes(venueId, count);

  return httpClient
    .get(endpoint, VENUE_FEATURE_PROBE_HTTP_CONFIG)
    .then(transformClientResponse)
    .then(removeClassesWithWhitespaceOnlyNames);
};

export default makeEntityScaffold('SAGA.API.FETCH_SCHEDULES_CLASSES', handler, { defaultKey: 1 });
